export const content = {
  en: {
    title: "Welcome to ICG GAMING",
    description: "ICG GAMING is White Label and Software Solutions for online casino and bookmaker website. At ICG Gaming, we have years of experience starting and growing successful online casino businesses.",
    buttonText: "Contact Us",
    footerText: "Join Us On Telegram"
  },
  zh: {
    title: "欢迎来到ICG GAMING",
    description: "ICG GAMING是一站式综合包网，东南亚包网建设平台。我们不仅仅是一个系统供应商，我们还拥有领先博彩网站的系统与技术，跟上新时代脚步，永不停止的创造与创新。",
    buttonText: "与我们联系",
    footerText: "加入我们的Telegram"
  }
};
